define('RecipesAndEvents.Model', [
    'Backbone',
    'Utils'
], function RecipesAndEventsModel(
    Backbone,
    Utils
) {
    'use strict';

    return Backbone.Model.extend({
        urlRoot: Utils.getAbsoluteUrl(getExtensionAssetsPath('services/RecipesAndEvents.Service.ss'))
    });
});
